export default __webpack_public_path__ + "static/media/sessions_bot_notify_ru.d429bdea.jpg";